import { MarkDownTokenParser, fetchTokens } from "./markdown_token_parser.js";

import {
  darkenNavBar,
  loadNavBar,
  loadFooter,
  footerElements,
  setupNavBarLinks,
  loadDefaultLanguage,
  setLanguage,
} from "./static.js";

// Import internationalization
import headerFi from "bundle-text:../public/content-md/index/header-fi.md";
import headerSv from "bundle-text:../public/content-md/index/header-sv.md";
import headerEn from "bundle-text:../public/content-md/index/header-en.md";
import heroFi from "bundle-text:../public/content-md/index/hero-fi.md";
import heroSv from "bundle-text:../public/content-md/index/hero-sv.md";
import heroEn from "bundle-text:../public/content-md/index/hero-en.md";
import contactFormFi from "bundle-text:../public/content-md/index/contact_form-fi.md";
import contactFormSv from "bundle-text:../public/content-md/index/contact_form-sv.md";
import contactFormEn from "bundle-text:../public/content-md/index/contact_form-en.md";
import navbarFi from "bundle-text:../public/content-md/navbar/navbar-fi.md";
import navbarSv from "bundle-text:../public/content-md/navbar/navbar-sv.md";
import navbarEn from "bundle-text:../public/content-md/navbar/navbar-en.md";
import footerFi from "bundle-text:../public/content-md/footer/footer-fi.md";
import footerSv from "bundle-text:../public/content-md/footer/footer-sv.md";
import footerEn from "bundle-text:../public/content-md/footer/footer-en.md";

const markdownContent = {
  fi: {
    navbar: navbarFi,
    header: headerFi,
    hero: heroFi,
    contact_form: contactFormFi,
    footer: footerFi,
  },
  sv: {
    navbar: navbarSv,
    header: headerSv,
    hero: heroSv,
    contact_form: contactFormSv,
    footer: footerSv,
  },
  en: {
    navbar: navbarEn,
    header: headerEn,
    hero: heroEn,
    contact_form: contactFormEn,
    footer: footerEn,
  },
};

class PlaceholderParser extends MarkDownTokenParser {
  async render() {
    const resultObj = await this.data;
    const keys = Object.keys(resultObj);
    keys.forEach((key) => {
      // console.log(`Rendering ${key}`);
      const currElement = document.querySelector(`#${key}`);
      if (["contact_form-button_submit", "contact_form-title"].includes(key)) {
        // console.log(`Setting ${key} to value ${resultObj[key]}`);
        currElement.innerHTML = resultObj[key];

        currElement.classList.remove("placeholder", "placeholder-wave");
      } else {
        const placeholderString = resultObj[key]
          .trim()
          .replace(/^<p>|<\/p>$/g, "");
        // console.log(`Setting ${key} to value ${placeholderString}`);
        currElement.setAttribute("placeholder", placeholderString); // = resultObj[key];
      }
    });
  }
}

async function renderContent(lang = "fi") {
  const navbarContent = new MarkDownTokenParser(markdownContent[lang].navbar);
  const headerContent = new MarkDownTokenParser(markdownContent[lang].header);
  const heroContent = new MarkDownTokenParser(markdownContent[lang].hero);
  const contactFormContent = new PlaceholderParser(
    markdownContent[lang].contact_form
  );
  const footerContent = new MarkDownTokenParser(markdownContent[lang].footer);

  await navbarContent.render();
  await headerContent.render();
  await heroContent.render();
  await contactFormContent.render();
  await footerContent.render();
}

document.addEventListener("DOMContentLoaded", () => {
  loadNavBar()
    .then(() => {
      // console.log("Navbar loaded");
      darkenNavBar();

      const languageButtons = document.querySelector("#navbar-changeLanguage");
      const languageFlags = document.querySelectorAll(".navbar-language-flag");
      // console.log(languageButtons);
      languageButtons.addEventListener("click", (e) => {
        e.preventDefault();
        // console.log("Ping");
        if (e.target.id === "changeFinnish") {
          renderContent("fi");
          setLanguage("fi");
          languageFlags.forEach((flag) => {
            flag.classList.remove("active");
          });
          e.target.classList.add("active");
        } else if (e.target.id === "changeSwedish") {
          renderContent("sv");
          setLanguage("sv");
          languageFlags.forEach((flag) => {
            flag.classList.remove("active");
          });
          e.target.classList.add("active");
        } else if (e.target.id === "changeEnglish") {
          renderContent("en");
          setLanguage("en");
          languageFlags.forEach((flag) => {
            flag.classList.remove("active");
          });
          e.target.classList.add("active");
        }
      });
    })
    .then(() => loadFooter())
    .then(() => setupNavBarLinks())

    .then(() => loadDefaultLanguage())
    .then((lang) => renderContent(lang));
  // renderContent("fi");
});
